import React from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';

export function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <nav className='bg-white fixed w-full z-50 shadow-sm'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between h-16'>
          <div className='flex items-center'>
            <a href='#hero'>
              <Logo />
              {/* <span className="text-2xl font-bold text-blue-600">Evision</span> */}
            </a>
          </div>

          <button
            onClick={() => {
              window.location.href = '/forceLogin';
            }}
          >
            Allez au CRM
          </button>

          <div className='hidden md:flex items-center space-x-8'>
            <a href='#features' className='text-gray-600 hover:text-blue-600'>
              Fonctionnalités
            </a>
            <a href='#pricing' className='text-gray-600 hover:text-blue-600'>
              Tarifs
            </a>
            {/* <a href="#gallery" className="text-gray-600 hover:text-blue-600">Comment ça marche</a> */}
            <a href='#contact' className='text-gray-600 hover:text-blue-600'>
              Contactez-nous
            </a>
            {/* <button className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors">
              Essai gratuit
            </button> */}
          </div>

          <div className='md:hidden flex items-center'>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className='text-gray-600'
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className='md:hidden'>
          <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
            <a href='#features' className='block px-3 py-2 text-gray-600'>
              Fonctionnalités
            </a>
            <a href='#pricing' className='block px-3 py-2 text-gray-600'>
              Tarifs
            </a>
            {/* <a href="#gallery" className="block px-3 py-2 text-gray-600">Comment Ca Marche</a> */}
            <a href='#contact' className='block px-3 py-2 text-gray-600'>
              Contact
            </a>

            {/* <button className="w-full text-center bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors">
              Essai gratuit
            </button> */}
          </div>
        </div>
      )}
    </nav>
  );
}
